import Cookies from 'js-cookie'

const suffix = `_${process.env.PLATFORM_ENV}`
const TokenKey = 'accessManage_token' + suffix
const BarIdKey = 'accessManage_barId' + suffix
const BarNameKey = 'accessManage_barName' + suffix
const LocaleKey = 'accessManage_locale' + suffix
const LoginFormKey = 'accessManage_loginForm' + suffix
const ProjectTargetStrKey = 'accessManage_project_target_str' + suffix

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getBarId() {
  return Cookies.get(BarIdKey)
}

export function setBarId(token) {
  return Cookies.set(BarIdKey, token)
}

export function getBarName() {
  return Cookies.get(BarNameKey)
}

export function setBarName(token) {
  return Cookies.set(BarNameKey, token)
}

export function getLocale() {
  return Cookies.get(LocaleKey) || 'zh'
}

export function setLocale(value) {
  return Cookies.set(LocaleKey, value)
}

export function removeLocale() {
  return Cookies.remove(LocaleKey)
}

export function getLoginForm() {
  return Cookies.getJSON(LoginFormKey) || {}
}

export function setLoginForm(value) {
  return Cookies.set(LoginFormKey, value, { expires: 31 })
}

export function removeLoginForm() {
  return Cookies.remove(LoginFormKey)
}

export function getProjectTargetStr() {
  return Cookies.get(ProjectTargetStrKey) // 页面刷新时使用
}

export function setProjectTargetStr(value) {
  return Cookies.set(ProjectTargetStrKey, value, { expires: 7 })
}

export function removeProjectTargetStr() {
  return Cookies.remove(ProjectTargetStrKey)
}
